import React from "react"
import DynamicGoal from "./DynamicGoal/"
import DynamicDomain from "./DynamicDomain/"

export default function TypeDynamic(props) {
  const { field } = props
  switch (field.field_name) {
    case "domain":
      return <DynamicDomain {...props} />
    case "goal":
      return <DynamicGoal {...props} />
    default:
      return null
  }
}
